import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Clipboard } from '@capacitor/clipboard';
import { AlertService } from 'src/app/services/alert/alert.service';
import { FcmService } from 'src/app/services/fcm/fcm.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { User } from 'src/app/services/user/model/user';
import { UserService } from 'src/app/services/user/user.service';
import { TransactionService } from './../../services/transaction/transaction.service';

@Component({
  selector: 'app-feed',
  templateUrl: './feed.page.html',
  styleUrls: ['./feed.page.scss'],
})
export class FeedPage {
  public static readonly CLOSED_MODAL_DONATION = 'closedModalDonation';

  public loading = true;
  public openModalDonations = false;
  public openModalDonateNow = false;
  public updateCredits = false;
  public user: User = new User();

  constructor(
    private alertService: AlertService,
    private fcmService: FcmService,
    private loaderService: LoaderService,
    private router: Router,
    private storageService: StorageService,
    private transactionService: TransactionService,
    private userService: UserService
  ) {
    this.loading = true;
  }

  async ionViewWillEnter() {
    await this.loaderService.showLoader();
    this.loading = true;
    this.updateCredits = true;
    try {
      const [user, credits, statements] = await Promise.all([
        this.userService.getUser(),
        this.transactionService.getCredits(),
        this.userService.getStatements(),
      ]);
      this.user = user;
      this.user.credits = credits;
      this.user.statements = statements;
      this.fcmService.initPush();
    } catch (error) {
      console.error(error);
    } finally {
      await this.getShowDonations();
      await this.loaderService.hideLoader();
      this.loading = false;
      this.updateCredits = false;
    }
  }

  async getShowDonations() {
    await this.storageService
      .get(FeedPage.CLOSED_MODAL_DONATION)
      .then((res) => {
        this.openModalDonations = !res;
      });
  }

  setShowDonations() {
    this.storageService.store(FeedPage.CLOSED_MODAL_DONATION, true);
  }

  async onClickCopy() {
    const url =
      '00020126390014br.gov.bcb.pix0117doe@colapp.com.br5204000053039865802BR5915COLAPP NETWORKS6009URUSSANGA622605226ibxYOhP2UgM35mLjylTS36304B979';
    await Clipboard.write({
      string: url,
    });

    this.alertService.showAlertOK(
      'Link copiado para área de transferência!',
      'Cole esse código no seu app de pagamento!'
    );
  }

  onClickPrime() {
    this.router.navigate(['home/feed/plans']);
  }

  onClickMore() {
    window.open('https://colapp.com.br/', '_blank');
  }

  async onRefreshPage(event) {
    this.updateCredits = true;
    try {
      const [user, credits, statements] = await Promise.all([
        this.userService.getUser(),
        this.transactionService.getCredits(),
        this.userService.getStatements(),
      ]);
      this.user = user;
      this.user.credits = credits;
      this.user.statements = statements;
      this.fcmService.initPush();
    } catch (error) {
      console.error(error);
    } finally {
      this.updateCredits = false;
    }
    setTimeout(() => event.target.complete(), 2000);
  }
}
